import { render, staticRenderFns } from "./SettingsToggle.vue?vue&type=template&id=41836f15&"
import script from "./SettingsToggle.vue?vue&type=script&lang=js&"
export * from "./SettingsToggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\dnx-dpn\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41836f15')) {
      api.createRecord('41836f15', component.options)
    } else {
      api.reload('41836f15', component.options)
    }
    module.hot.accept("./SettingsToggle.vue?vue&type=template&id=41836f15&", function () {
      api.rerender('41836f15', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/TemplateManager/Components/Settings/SettingsToggle.vue"
export default component.exports